var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-message"},[_c('div',{staticClass:"loading-message__message"},[_vm._t("default",function(){return [_c('h2',[_vm._v(_vm._s(_vm.message))])]})],2),_c('spinner-component',{attrs:{"size":16}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }